<div class="summary-card">
  <div class="summary-content">
    <ion-icon [name]="icon" class="summary-icon" aria-hidden="true" />
    <div class="summary-text">
      <h3>{{ title }}</h3>
      @if (subtitle) {
      <p>{{ subtitle }}</p>
      }
    </div>
  </div>
  @if (progress !== null) {
  <div
    class="summary-progress"
    role="progressbar"
    aria-valuemin="0"
    aria-valuemax="100"
    [attr.aria-valuenow]="progressPercent"
    [attr.aria-label]="progressLabel || null"
  >
    <span class="summary-progress-fill" [style.width.%]="progressPercent"></span>
  </div>
  }
</div>
